import { axios, handleError } from '../axios';

export const adminGetMember = (pageNumber) => {
  return new Promise((resolve) => {
    axios
      .get('admin/member/', {
        params: {
          pn: pageNumber,
        },
      })
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
